/**
 * Advertisement block: init Swiper for each instance.
 */
(function () {
	'use strict';

	var CONFIG = {
		slidesPerView: 'auto',
		spaceBetween: 30,
		speed: 2000,
		autoplay: {
			delay: 4000,
			disableOnInteraction: false,
			reverseDirection: true,
		},
		loop: true,
		allowTouchMove: false,
		resistance: false,
		resistanceRatio: 0,
		pagination: {
			el: '.slider__pagination',
			clickable: true,
		},
		breakpoints: {
			320: { slidesPerView: 1, spaceBetween: 10 },
			768: { slidesPerView: 1, spaceBetween: 15 },
		},
	};

	function initSwipers() {
		if (typeof Swiper === 'undefined') return;
		var containers = document.querySelectorAll('.hhm-advertisement');
		containers.forEach(function (el) {
			if (el.swiper) return;
			new Swiper(el, CONFIG);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initSwipers);
	} else {
		initSwipers();
	}
})();
